// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"90f0bc93","687":"bb737bec"}[chunkId] + ".chunk.css";
};